import { IEntity } from './entity';
import { IQuerable } from './querable';

export type IMemoryStore<T extends IEntity = IEntity> = Record<string, T[]>;

export type IStore = Record<string, IQuerable>;

export type IConfig = {
  collections: string[];
  mocks: string[];
  pages: string[];
};

export type IPackages = {
  icons: string;
  models: string;
  ui: string;
};

export type ICollectionDescription = {
  singularName: string;
  pluralName: string;
  pluralDisplayName: string;
  displayName: string;
  title: string;
};

export type ISerializedCollection<T extends IEntity = IEntity> = ICollectionDescription & {
  items: T[];
};

export type ISerializedStore = Record<string, ISerializedCollection>;
